module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('div', {
    staticClass: "not-found-container",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('errors.not_support_country')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "link-back-main"
  }, [_c('a', {
    attrs: {
      "href": _vm.classtingUrl,
      "target": "_brank"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.go_back_to_other_app')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82d3edac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/errors/views/NotSupportCountry.vue
// module id = 1599
// module chunks = 1